<template>
  <div>
    <b-modal
      ref="modal-cadastro-produto"
      id="modal_cadastro_produto"
      :title="titulo"
      hide-footer
      no-stacking
    >
      <form @submit.prevent="cadastrarProduto">
        <div class="modal-body mx-3">
          <div>
            <b
              ><p align="center">
                Você pode anunciar sempre que tiver produtos disponíveis para
                venda.
              </p></b
            >
          </div>
          <br />
          <div>
            <b
              ><p align="center">
                Anuncie com frequência, os mercados cadastrados receberão sua
                oferta!
              </p></b
            >
          </div>
          <br />
          <div class="md-form">
            <label for="municipio">Propriedade:</label>
            <select
              class="form-control"
              id="propriedade"
              :disabled="propriedades.length === 0"
              v-model="payload.propriedadeId"
            >
              <option
                v-if="propriedades.length === 0"
                :selected="propriedades.length === 0"
              >
                Sem propriedades cadastradas
              </option>
              <option
                v-for="propriedade in propriedades"
                v-bind:value="propriedade.propriedadeId"
                v-bind:key="propriedade.propriedadeId"
              >
                {{ propriedade.nome }}
              </option>
            </select>
            <p v-if="propriedades.length === 0">
              Cadastre uma propriedade no menu Gerenciar meus dados -> Cadastrar
              Propriedade antes de continuar o cadastro do produto
            </p>
          </div>

          <div class="md-form">
            <label data-error="wrong" data-success="right" for="nome"
              >Produto:</label
            >
            <input
              type="text"
              id="nome"
              class="form-control validate"
              v-model="payload.nome"
              required
            />
          </div>

          <div class="md-form">
            <label
              data-error="wrong"
              data-success="right"
              for="quantidadeProduto"
              >Quantidade estimada: (opcional)</label
            >
            <input
              type="text"
              id="quantidadeProduto"
              class="form-control validate"
              v-model="payload.quantidade"
            />
          </div>

          <div class="md-form">
            <label for="municipio">Unidade de Medida: (opcional)</label>
            <select
              class="form-control"
              id="unidadeMedida"
              v-model="payload.unidadeMedidaId"
            >
              <option
                v-for="unidadeMedida in unidadesMedida"
                v-bind:value="unidadeMedida.unidadeMedidaId"
                v-bind:key="unidadeMedida.unidadeMedidaId"
              >
                {{ unidadeMedida.nome }}
              </option>
            </select>
          </div>
          <div class="md-form">
            <label data-error="wrong" data-success="right" for="descricao"
              >Descrição detalhada: (opcional)</label
            >
            <input
              type="text"
              id="descricao"
              class="form-control validate"
              v-model="payload.descricao"
            />
          </div>

          <div class="md-form">
            <label data-error="wrong" data-success="right" for="preco"
              >Estimativa de Preço: (opcional)</label
            >
            <input
              type="text"
              id="preco"
              class="form-control validate"
              step="0.01"
              min="0.01"
              v-model="payload.preco"
              @keyup="formatCurrency"
            />
          </div>

          <!--
          <div class="md-form form-sm">
            <label data-error="wrong" data-success="right" for="dataInicio">Este anúncio inicia em:</label>
            <input type="text" v-mask="'##/##/####'" id="dataInicio" class="form-control form-control-sm validate" v-model="payload.dataInicioString">
          </div>

          <div class="md-form form-sm">
            <label data-error="wrong" data-success="right" for="dataValidade">Este anúncio vale até:</label>
            <input type="text" v-mask="'##/##/####'" id="dataValidade" class="form-control form-control-sm validate" v-model="payload.dataValidadeString">
          </div>
          -->

          <div class="md-form form-sm">
            <input
              type="checkbox"
              id="produtoOrganico"
              class="form-check-input validate"
              v-model="payload.organico"
            />
            <label for="produtoOrganico">Produto Orgânico?</label>
          </div>

          <div class="md-form" v-if="payload.organico">
            <label for="municipio">Entidade Certificadora:</label>
            <select
              class="form-control"
              id="entidadeCertificadora"
              v-model="payload.entidadeCertificadoraId"
              :required="payload.organico"
            >
              <option
                v-for="entidadeCertificadora in entidadesCertificadoras"
                v-bind:value="entidadeCertificadora.entidadeCertificadoraId"
                v-bind:key="entidadeCertificadora.entidadeCertificadoraId"
              >
                {{ entidadeCertificadora.nome }}
              </option>
            </select>
          </div>

          <div class="md-form" v-if="payload.entidadeCertificadoraId === 1">
            <label
              data-error="wrong"
              data-success="right"
              for="outraEntidadeCertificadora"
              >Outra Entidade Certificadora:</label
            >
            <input
              type="text"
              id="outraEntidadeCertificadora"
              class="form-control validate"
              v-model="payload.outraEntidadeCertificadora"
            />
          </div>

          <div class="md-form">
            <i class="fas fa-user prefix grey-text"></i>
            <label data-error="wrong" data-success="right" for="lead"
              >Imagens:</label
            >
            <input
              type="file"
              multiple
              label="Selecione as imagens"
              @change="adicionarImagem($event)"
            />
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-center">
          <button
            class="btn btn-primary"
            type="submit"
            :disabled="!payload.propriedadeId"
          >
            {{ textoBotao }}
          </button>
        </div>
      </form>
      <div>
        <b>Seus produtos anunciados:</b>
        <table
          id="produtos"
          class="table table-striped table-hover table-sm"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th></th>
              <th></th>
              <!-- <th>Desabilitar</th> -->
            </tr>
          </thead>
          <tbody v-for="produto in produtos" v-bind:key="produto.produtoId">
            <tr>
              <td>
                <!-- <a href="#" @click="confirmarDelete(produto)"> -->
                <a href="#" @click="excluirProduto(produto)"> Excluir </a>
              </td>
              <td>
                <div>
                  <a
                    href="#"
                    @click="editarProduto(produto)"
                    v-b-modal.modal_cadastro_produto
                  >
                    {{ produto.nome }}
                  </a>
                </div>
              </td>
              <!--
                <td align="center"><input type="checkbox" :id="'produto' + produto.produtoId" class="form-check-input validate" @change="changeProduto(produto)" v-model="produto.inativo"></td>
                -->
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  entidadeCertificadoraAPI,
  produtoAPI,
  propriedadeAPI,
  unidadeMedidaAPI,
} from "@/modules/home";

export default {
  computed: {
    ...mapGetters(["user"]),
    titulo() {
      if (this.payload.produtoId) {
        return "Atualizar Anúncio de Produto";
      }
      return "Cadastrar anúncio de Produto";
    },
    textoBotao() {
      if (this.payload.produtoId) {
        return "Atualizar";
      }
      return "Cadastrar";
    },
  },
  components: {},
  data() {
    return {
      payload: {
        organico: false,
      },
      propriedades: [],
      unidadesMedida: [],
      entidadesCertificadoras: [],
      produtos: {},
      confirmaDelete: "",
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    listarPropriedades() {
      propriedadeAPI
        .listByUsuario()
        .then((resp) => {
          this.propriedades = resp.data;
        })
        .catch((resp) => {
          this.setLoading(false);
        });
    },
    listarUnidadesMedida() {
      unidadeMedidaAPI
        .list()
        .then((resp) => {
          this.unidadesMedida = resp.data;
        })
        .catch((resp) => {
          this.setLoading(false);
        });
    },
    listarEntidadesCertificadoras() {
      entidadeCertificadoraAPI
        .list()
        .then((resp) => {
          this.entidadesCertificadoras = resp.data;
        })
        .catch((resp) => {
          this.setLoading(false);
        });
    },
    cadastrarProduto() {
      this.setLoading(true);

      const formData = new FormData();

      if (this.payload.imagens) {
        for (let i = 0; i < this.payload.imagens.length; i++) {
          formData.append("imagens", this.payload.imagens[i]);
        }
      }
      if (this.payload.produtoId) {
        formData.append("produtoId", this.payload.produtoId);
      }
      formData.append("propriedadeId", this.payload.propriedadeId);
      formData.append("nome", this.payload.nome);
      // formData.append('dataValidadeString', this.payload.dataValidadeString)
      // formData.append('dataInicioString', this.payload.dataInicioString)
      formData.append("organico", this.payload.organico);
      if (this.payload.entidadeCertificadoraId) {
        formData.append(
          "entidadeCertificadoraId",
          this.payload.entidadeCertificadoraId
        );
      }
      if (this.payload.outraEntidadeCertificadora) {
        formData.append(
          "outraEntidadeCertificadora",
          this.payload.outraEntidadeCertificadora
        );
      }
      if (this.payload.unidadeMedidaId) {
        formData.append("unidadeMedidaId", this.payload.unidadeMedidaId);
      }
      if (this.payload.quantidade) {
        formData.append("quantidade", this.payload.quantidade);
      }
      if (this.payload.descricao) {
        formData.append("descricao", this.payload.descricao);
      }
      if (this.payload.preco) formData.append("preco", this.payload.preco);

      const promisse = this.payload.produtoId
        ? produtoAPI.update(formData)
        : produtoAPI.create(formData);

      promisse
        // produtoAPI.create(formData)
        .then((resp) => {
          this.setLoading(false);
          // document.getElementById('fecharModalInserirProduto').click()
          this.payload = {};
          this.$toast("Produto salvo com sucesso", {
            timeout: 2000,
            hideProgressBar: true,
          });
          // document.querySelector('#modal_cadastro_produto___BV_modal_header_ > button').click()
        })
        .catch((resp) => {
          this.setLoading(false);
          console.log(resp);
          this.$toast.error("Erro ao salvar Produto", {
            timeout: 2000,
            hideProgressBar: true,
          });
          // document.getElementById('fecharModalInserirProduto').click()
        });
    },
    adicionarImagem(event) {
      this.payload.imagens = event.target.files;
    },
    confirmarDelete(produto) {
      this.confirmaDelete = "";
      this.$bvModal
        .msgBoxConfirm(
          "Tem certeza que deseja DELETAR permanentemente o produto?",
          {
            title: "Confirmar Ação",
            size: "sm",
            buttonSize: "sm",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            okVariant: "danger",
            okTitle: "SIM",
            cancelTitle: "NÃO",
          }
        )
        .then((value) => {
          this.confirmaDelete = value;
          if (value === true) {
            this.excluirProduto(produto);
          }
        });
    },
    excluirProduto(produto) {
      this.setLoading(true);
      produtoAPI
        .delete(produto.produtoId)
        .then((resp) => {
          this.setLoading(false);
          this.$toast("Produto deletado com sucesso", {
            timeout: 2000,
            hideProgressBar: true,
          });
          this.listarMeusProdutos();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$toast.error("Erro ao deletar Produto", {
            timeout: 2000,
            hideProgressBar: true,
          });
        });
    },
    editarProduto(produto) {
      // eslint-disable-next-line no-undef
      // $('#modal_cadastro_produto').modal()
      this.$store.commit("SET_PRODUTO", produto);
    },
    listarMeusProdutos() {
      this.setLoading(true);

      produtoAPI
        .listarMeusProdutos()
        .then((resp) => {
          this.produtos = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          if (this.isAuthenticated) {
            this.$toast.error("Erro ao Listar Produtos", {
              timeout: 2000,
              hideProgressBar: true,
            });
          }
        });
    },
    formatCurrency(e) {
      var v = e.target.value.replace(/\D/g, "");
      v = (v / 100).toFixed(2) + "";
      v = v.replace(".", ",");
      v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
      this.payload.preco = v;
    },
    changeProduto(produto) {
      this.setLoading(true);

      produtoAPI
        .update(produto)
        .then((resp) => {
          this.setLoading(false);
          this.$toast("Produto Atualizado", {
            timeout: 2000,
            hideProgressBar: true,
          });
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$toast.error("Erro ao Atualizar Produto", {
            timeout: 2000,
            hideProgressBar: true,
          });
        });
    },
  },

  created() {
    if (this.user) this.listarPropriedades();
    if (this.user) this.listarUnidadesMedida();
    if (this.user) this.listarEntidadesCertificadoras();
    if (this.user) this.listarMeusProdutos();
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "SET_PRODUTO") {
        this.payload = mutation.payload;
        if (!this.payload.propriedadeId) {
          this.propriedades = "Administrador";
          this.payload.propriedadeId =
            mutation.payload.propriedade.propriedadeId;
        }
        if (this.payload.dataValidadeString) {
          this.payload.dataValidadeString =
            mutation.payload.dataValidade.substring(8, 10) +
            "/" +
            mutation.payload.dataValidade.substring(5, 7) +
            "/" +
            mutation.payload.dataValidade.substring(0, 4);
        }
        if (this.payload.dataInicioString) {
          this.payload.dataInicioString =
            mutation.payload.dataInicio.substring(8, 10) +
            "/" +
            mutation.payload.dataInicio.substring(5, 7) +
            "/" +
            mutation.payload.dataInicio.substring(0, 4);
        }
        if (this.payload.preco) this.payload.preco = mutation.payload.preco;
      }
    });
  },
};
</script>
